<template>
    <div class="commentsArea" :class="{small: isSmall}">

        <p v-if="!isSmall" class="block_title">Comments</p>
        <div class="empty" v-if="comments === null && !isSmall">No Comments here yet.</div>

        <div v-if="comments !== null && typeof(comments) !== 'undefined'">
            <div v-if="comments.length > 0" class="allCommentsArea">
                <div v-for="comment in comments" :key="comment.id" class="comment">
                    
                    <div class="avatar" :style="{backgroundImage: 'url('+ comment.authorImage +')'}"></div>
                    
                    <p class="commentText">
                        <span class="commentName">{{ comment.authorName }}</span> - {{ comment.comment }}
                    </p>
                    
                    <!--Delete Comment Btn-->
                    <a href="#0" v-if="$store.state.currentUser.uid === comment.authorId || $store.state.currentUser.uid === 'MxARUElzBNhyyJbdwYkOL55vxxJ2'" @click.prevent="deleteComment(comment.id)" class="deleteCommentBtn">
                        <ion-icon name="trash"></ion-icon>
                    </a>

                    <p class="commentDate">{{ comment.timestamp.toDate() | commentDate }}</p>
                </div>
            </div>
        </div>
        
        <div v-if="$store.state.currentUser !== null" class="addCommentArea" :class="{init: commentInit}">

            <a href="#0" v-if="!commentInit" @click.prevent="addCommentInit()" class="btn green icon-left"><ion-icon name="chatbox-ellipses"></ion-icon> Comment</a><br>

            <div v-if="commentInit">
                <div class="avatar" :style="{backgroundImage: 'url('+ $store.state.currentUser.photoURL +')'}"></div>

                <textarea v-model="commentTextArea" :class="{error: commentsError !== null}"></textarea>

                <div v-if="commentTextArea !== null">
                    <a href="#0" v-if="commentTextArea.length > 0" @click.prevent="addComment()" class="btn green addCommentBtn">Add Comment</a>
                </div>

                <span v-if="commentsError !== null" class="commentError error">{{ commentsError }}</span>
            </div>
        </div>

    </div>
</template>

<script>
import moment from 'moment'

export default {
    data(){
        return{
            commentInit: false,
            commentsRef: null,
            comments: [],
            commentTextArea: '',
            commentsError: null
        }
    },
    props: {
        type: String,
        collectionId: String,
        docId: String,
        isSmall: Boolean,
        isOpen: {
            value: Boolean,
            default: false
        }
    },

    async created(){
        await this.$bind('comments', this.$firebase.firestore().collection(this.collectionId).doc(this.docId).collection('comments'))

        if(this.isOpen){
            this.commentInit = true
        }
    },

    methods: {
        getCommentsRef(){
            return this.$firebase.firestore().collection(this.collectionId).doc(this.docId).collection('comments')
        },
        getComments(){

            let self = this
            let commentsRef = self.getCommentsRef()

            commentsRef.orderBy('timestamp', 'asc').get().then(snap => {
                if(snap){

                    let allComments = []
                    
                    snap.forEach(function(doc){
                        let comment = {}
                        comment = doc.data()
                        comment.id = doc.id
                        allComments.push(comment)
                    })

                    self.comments = allComments
                    allComments = []

                }else{
                    console.log('No comments found.')
                }
            }).catch(err => {
                console.log('Error getting comments: ', err)
                self.commentsError = 'Error getting comments'
            })
        },
        addCommentInit(){
            this.commentInit = true
        },
        addComment(){

            let self = this
            let commentsRef = self.getCommentsRef()

            if(!self.commentTextArea){
                self.commentsError = 'Message field must have test'
                return
            }

            commentsRef.add({
                authorId: self.$store.state.currentUser.uid,
                authorImage: self.$store.state.currentUser.photoURL,
                authorName: self.$store.state.userProfile.firstName,
                comment: self.commentTextArea,
                timestamp: this.$firebase.firestore.FieldValue.serverTimestamp()
            })
            .then(docRef => {

                console.log('New comment added with id: ', self.commentTextArea, docRef.id)

                self.getComments()
                self.commentTextArea = ''
                self.commentsError = null
            })
            .catch(err => {
                console.log('Error adding a comment: ', err)
                self.commentsError = err.message
            })
        },
        deleteComment(commentId){

            let self = this
            let commentsRef = self.getCommentsRef()
            let commentRef = commentsRef.doc(commentId)

            if(confirm('Are you sure you want to delete this comment?')){

                commentRef.delete().then(docRef => {

                    self.getComments()
                    self.commentTextArea = ''
                    self.commentsError = null

                }).catch(err => {
                    console.log('Error deleting comment: ', err)
                    self.commentsError = 'Error deleting comment.'
                })
            }
        }
    },
    filters: {
        commentDate(value){

            let comDate = moment(value)
            let today = moment()
            let diff = today.diff(comDate, 'days')

            let formattedDate = ''
            
            if(diff === 0){
                formattedDate = comDate.format('h:mm a')
            }else if(diff > 1){
                formattedDate = diff + ' days ago'
            }else if(diff > 7){
                formattedDate = comDate.format('MMM DD - h:mm a')
            }
            
            return formattedDate 
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Comments.vue